import React, { useState, useEffect, useCallback } from 'react';

const SlideShow = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Updated banners for clothing collection
  const banners = [
    "./banner.jpg",
    
  ];

  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  }, [banners.length]);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + banners.length) % banners.length);
  };

  // Auto-slide
  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <div className="relative w-full max-w-7xl mx-auto overflow-hidden bg-gray-50 group">
      {/* Images */}
      {banners.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`Slide ${index + 1}`}
          className="w-full h-auto block"
          style={{
            display: index === currentIndex ? 'block' : 'none'
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "https://via.placeholder.com/1200x400/F3F4F6/9CA3AF?text=NAa+Collection+Banner+" + (index + 1);
          }}
        />
      ))}

      {/* Navigation Buttons - Changed to Black theme */}
      <button 
        onClick={prevSlide}
        className="absolute top-1/2 -translate-y-1/2 left-4 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white border border-gray-200 text-gray-600 text-2xl md:text-3xl font-light cursor-pointer hover:bg-black hover:text-white hover:border-black hover:scale-110 opacity-0 group-hover:opacity-100 transition-all shadow-md z-10"
        aria-label="Previous slide"
      >
        ‹
      </button>
      <button 
        onClick={nextSlide}
        className="absolute top-1/2 -translate-y-1/2 right-4 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white border border-gray-200 text-gray-600 text-2xl md:text-3xl font-light cursor-pointer hover:bg-black hover:text-white hover:border-black hover:scale-110 opacity-0 group-hover:opacity-100 transition-all shadow-md z-10"
        aria-label="Next slide"
      >
        ›
      </button>

     

      {/* Bottom Gradient Overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/5 to-transparent pointer-events-none" />
    </div>
  );
};

export default SlideShow;